export default "__VITE_ASSET__CJ0Y_WpW__"